import {createApp} from 'vue'
import App from './App.vue'
import "./input.css"

createApp(App).mount('#weeconnectpay-app-wrapper')
